import { lazy } from "@website/ui/lazy";

export const HotelVideoPlayer = lazy(() =>
  import("./hotel-video-player").then(
    ({ HotelVideoPlayer }) => HotelVideoPlayer
  )
);
